import { withInstall } from '../../utils/vue-utils'
import _Step from '../steps/src/step.vue'

export const Step = withInstall(_Step)
export type StepInstance = InstanceType<typeof _Step>
export default Step
